import React, { useState, useEffect } from 'react';
import withAuthAdmin from '../../routes/withAuthAdmin';
import { 
  getEstadisticasDashboard, 
  getResumenGeneralTareas,
  getTareasPorArea, 
  getConteoAnidadoTareas,
  getHorasPromedioResolucion, 
  getRankingSoporteTecnico,
  descargarReporteExcel,
  descargarReporteTareasCerradas,
  getDiagnosticoSinFiltro,
  getTareasDetalle,
  descargarReporteTodasTareas
} from '../../services/Admin/tareasAdminService';
import { getAreas } from '../../services/Admin/areaService';
import { getCategoriasByArea } from '../../services/Admin/categoriaService';
import { getSubcategoriasByCategoria } from '../../services/Admin/subcategoriaService';

const EstadisticasPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [estadisticas, setEstadisticas] = useState({
    totalTareas: 0,
    tareasPendientes: 0,
    tareasCompletadas: 0
  });
  const [tareasPorArea, setTareasPorArea] = useState([]);
  const [conteoAnidado, setConteoAnidado] = useState({
    totalTareas: 0,
    areas: []
  });
  const [horasPromedio, setHorasPromedio] = useState(0);
  const [rankingSoporte, setRankingSoporte] = useState([]);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [areaId, setAreaId] = useState('');
  const [categoriaId, setCategoriaId] = useState('');
  const [subcategoriaId, setSubcategoriaId] = useState('');
  const [areas, setAreas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [loadingAreas, setLoadingAreas] = useState(false);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [loadingSubcategorias, setLoadingSubcategorias] = useState(false);
  const [endpointsDisponibles, setEndpointsDisponibles] = useState({
    dashboard: true,
    area: true,
    conteoAnidado: true,
    horas: true,
    ranking: true
  });
  const [descargandoReporte, setDescargandoReporte] = useState(false);
  const [descargandoReporteCerradas, setDescargandoReporteCerradas] = useState(false);
  const [descargandoReporteTodas, setDescargandoReporteTodas] = useState(false);

  useEffect(() => {
    // Establecer fechas por defecto (último mes)
    const hoy = new Date();
    const haceUnMes = new Date();
    haceUnMes.setMonth(hoy.getMonth() - 1);
    
    const fechaInicioDefault = haceUnMes.toISOString().split('T')[0];
    const fechaFinDefault = hoy.toISOString().split('T')[0];
    
    setFechaInicio(fechaInicioDefault);
    setFechaFin(fechaFinDefault);
    
    cargarDatosIniciales(fechaInicioDefault, fechaFinDefault);
  }, []);

  const cargarDatosIniciales = async (fechaInicioParam, fechaFinParam) => {
    try {
      // Cargar áreas
      setLoadingAreas(true);
      setError('');
      try {
        console.log('API_BASE_URL:', process.env.REACT_APP_API_URL);
        console.log('Token disponible:', !!localStorage.getItem('authToken'));
        const data = await getAreas();
        console.log('Datos de áreas recibidos:', data);
        console.log('Tipo de datos:', typeof data);
        console.log('Es array:', Array.isArray(data));
        
        if (data && Array.isArray(data)) {
          setAreas(data);
        } else if (data && data.data && Array.isArray(data.data)) {
          setAreas(data.data);
        } else {
          console.warn('Formato de datos inesperado para áreas:', data);
          setAreas([]);
        }
      } catch (err) {
        console.error('Error al cargar áreas:', err);
        setError('Error al cargar áreas: ' + (err.message || 'Error desconocido'));
        setAreas([]);
      } finally {
        setLoadingAreas(false);
      }

      // Cargar estadísticas
      await cargarEstadisticas(fechaInicioParam, fechaFinParam);
    } catch (error) {
      console.error('Error cargando datos iniciales:', error);
      setError('Error al cargar los datos iniciales');
      setLoadingAreas(false);
    }
  };

  // Cargar Categorías cuando areaId cambie
  useEffect(() => {
    if (areaId) {
      const fetchCategorias = async () => {
        setLoadingCategorias(true);
        setError('');
        setCategorias([]);
        setCategoriaId('');
        setSubcategorias([]);
        setSubcategoriaId('');
        try {
          const data = await getCategoriasByArea(areaId);
          console.log('Datos de categorías recibidos para área', areaId, ':', data);
          console.log('Tipo de datos:', typeof data);
          console.log('Es array:', Array.isArray(data));
          
          if (data && Array.isArray(data)) {
            setCategorias(data);
          } else if (data && data.data && Array.isArray(data.data)) {
            setCategorias(data.data);
          } else {
            console.warn('Formato de datos inesperado para categorías:', data);
            setCategorias([]);
          }
        } catch (err) {
          console.error('Error al cargar categorías:', err);
          setError('Error al cargar categorías: ' + (err.message || 'Error desconocido'));
          setCategorias([]);
        } finally {
          setLoadingCategorias(false);
        }
      };
      fetchCategorias();
    } else {
      setCategorias([]);
      setCategoriaId('');
      setSubcategorias([]);
      setSubcategoriaId('');
    }
  }, [areaId]);

  // Cargar Subcategorías cuando categoriaId cambie
  useEffect(() => {
    if (categoriaId) {
      const fetchSubcategorias = async () => {
        setLoadingSubcategorias(true);
        setError('');
        setSubcategorias([]);
        setSubcategoriaId('');
        try {
          const data = await getSubcategoriasByCategoria(categoriaId);
          console.log('Datos de subcategorías recibidos para categoría', categoriaId, ':', data);
          console.log('Tipo de datos:', typeof data);
          console.log('Es array:', Array.isArray(data));
          
          if (data && Array.isArray(data)) {
            setSubcategorias(data);
          } else if (data && data.data && Array.isArray(data.data)) {
            setSubcategorias(data.data);
          } else {
            console.warn('Formato de datos inesperado para subcategorías:', data);
            setSubcategorias([]);
          }
        } catch (err) {
          console.error('Error al cargar subcategorías:', err);
          setError('Error al cargar subcategorías: ' + (err.message || 'Error desconocido'));
          setSubcategorias([]);
        } finally {
          setLoadingSubcategorias(false);
        }
      };
      fetchSubcategorias();
    } else {
      setSubcategorias([]);
      setSubcategoriaId('');
    }
  }, [categoriaId]);

  const cargarEstadisticas = async (fechaInicioParam, fechaFinParam, areaIdParam = null, categoriaIdParam = null, subcategoriaIdParam = null) => {
    try {
      setLoading(true);
      setError(null);

      // Cargar estadísticas del dashboard con filtros
      const dashboardResponse = await getResumenGeneralTareas(fechaInicioParam, fechaFinParam, areaIdParam, categoriaIdParam, subcategoriaIdParam);
      if (dashboardResponse.success) {
        setEstadisticas(dashboardResponse.data);
        setEndpointsDisponibles(prev => ({ ...prev, dashboard: true }));
      } else {
        console.error('Error cargando dashboard:', dashboardResponse.message);
        setEndpointsDisponibles(prev => ({ ...prev, dashboard: false }));
        // Datos de ejemplo si el endpoint no está disponible
        setEstadisticas({
          totalTareas: 250,
          tareasPendientes: 80,
          tareasCompletadas: 170
        });
      }

      // Cargar tareas por área con filtros
      const areaResponse = await getTareasPorArea(fechaInicioParam, fechaFinParam, areaIdParam, categoriaIdParam, subcategoriaIdParam);
      if (areaResponse.success) {
        setTareasPorArea(areaResponse.data);
        setEndpointsDisponibles(prev => ({ ...prev, area: true }));
      } else {
        console.error('Error cargando tareas por área:', areaResponse.message);
        setEndpointsDisponibles(prev => ({ ...prev, area: false }));
        // Datos de ejemplo si el endpoint no está disponible
        setTareasPorArea([
          { areaNombre: 'Soporte Técnico', cantidad: 50 },
          { areaNombre: 'Desarrollo', cantidad: 35 },
          { areaNombre: 'QA', cantidad: 25 },
          { areaNombre: 'Diseño', cantidad: 20 },
          { areaNombre: 'Marketing', cantidad: 20 }
        ]);
      }

      // Cargar conteo anidado de tareas con filtros
      const conteoAnidadoResponse = await getConteoAnidadoTareas(fechaInicioParam, fechaFinParam, areaIdParam, categoriaIdParam, subcategoriaIdParam);
      if (conteoAnidadoResponse.success) {
        setConteoAnidado(conteoAnidadoResponse.data);
        setEndpointsDisponibles(prev => ({ ...prev, conteoAnidado: true }));
      } else {
        console.error('Error cargando conteo anidado:', conteoAnidadoResponse.message);
        setEndpointsDisponibles(prev => ({ ...prev, conteoAnidado: false }));
        // Datos de ejemplo si el endpoint no está disponible
        setConteoAnidado({
          totalTareas: 150,
          areas: [
            {
              areaId: 1,
              areaNombre: 'Soporte Técnico',
              numeroDeTareas: 75,
              categorias: [
                {
                  categoriaId: 1,
                  categoriaNombre: 'Hardware',
                  numeroDeTareas: 30,
                  subcategorias: [
                    {
                      subcategoriaId: 1,
                      subcategoriaNombre: 'Computadoras',
                      numeroDeTareas: 15
                    },
                    {
                      subcategoriaId: 2,
                      subcategoriaNombre: 'Impresoras',
                      numeroDeTareas: 10
                    }
                  ]
                },
                {
                  categoriaId: 2,
                  categoriaNombre: 'Software',
                  numeroDeTareas: 45,
                  subcategorias: [
                    {
                      subcategoriaId: 3,
                      subcategoriaNombre: 'Sistema Operativo',
                      numeroDeTareas: 25
                    }
                  ]
                }
              ]
            }
          ]
        });
      }

      // Cargar horas promedio de resolución con filtros
      const horasResponse = await getHorasPromedioResolucion(fechaInicioParam, fechaFinParam, areaIdParam, categoriaIdParam, subcategoriaIdParam);
      if (horasResponse.success) {
        setHorasPromedio(horasResponse.data.horasPromedio || 0);
        setEndpointsDisponibles(prev => ({ ...prev, horas: true }));
      } else {
        console.error('Error cargando horas promedio:', horasResponse.message);
        setHorasPromedio(0);
        setEndpointsDisponibles(prev => ({ ...prev, horas: false }));
      }

      // Cargar ranking de soporte técnico (solo con areaId)
      const rankingResponse = await getRankingSoporteTecnico(fechaInicioParam, fechaFinParam, areaIdParam);
      if (rankingResponse.success) {
        setRankingSoporte(rankingResponse.data);
        setEndpointsDisponibles(prev => ({ ...prev, ranking: true }));
      } else {
        console.error('Error cargando ranking:', rankingResponse.message);
        setEndpointsDisponibles(prev => ({ ...prev, ranking: false }));
        // Si el endpoint no está disponible, mostrar datos de ejemplo
        setRankingSoporte([
          {
            usuarioResponsableId: 1,
            nombreResponsable: 'Juan Pérez',
            emailResponsable: 'juan.perez@empresa.com',
            areaNombre: 'Soporte Técnico',
            promedioCalificacion: 4.8,
            totalTareasAsignadas: 25,
            totalTareasCompletadas: 23,
            porcentajeCompletado: 92.0,
            totalCalificaciones: 23
          },
          {
            usuarioResponsableId: 2,
            nombreResponsable: 'María García',
            emailResponsable: 'maria.garcia@empresa.com',
            areaNombre: 'Soporte Técnico',
            promedioCalificacion: 4.5,
            totalTareasAsignadas: 18,
            totalTareasCompletadas: 17,
            porcentajeCompletado: 94.44,
            totalCalificaciones: 17
          },
          {
            usuarioResponsableId: 3,
            nombreResponsable: 'Carlos López',
            emailResponsable: 'carlos.lopez@empresa.com',
            areaNombre: 'Soporte Técnico',
            promedioCalificacion: 4.2,
            totalTareasAsignadas: 15,
            totalTareasCompletadas: 14,
            porcentajeCompletado: 93.33,
            totalCalificaciones: 14
          }
        ]);
      }

    } catch (error) {
      setError('Error al cargar las estadísticas');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const actualizarEstadisticas = async () => {
    if (!fechaInicio || !fechaFin) {
      setError('Por favor, seleccione ambas fechas.');
      return;
    }
    
    // Convertir los valores vacíos a null para los filtros opcionales
    const areaIdParam = areaId === '' ? null : parseInt(areaId);
    const categoriaIdParam = categoriaId === '' ? null : parseInt(categoriaId);
    const subcategoriaIdParam = subcategoriaId === '' ? null : parseInt(subcategoriaId);
    
    await cargarEstadisticas(fechaInicio, fechaFin, areaIdParam, categoriaIdParam, subcategoriaIdParam);
  };

  const handleAreaChange = (e) => {
    setAreaId(e.target.value);
  };

  const handleCategoriaChange = (e) => {
    setCategoriaId(e.target.value);
  };

  const handleSubcategoriaChange = (e) => {
    setSubcategoriaId(e.target.value);
  };

  const limpiarFiltros = () => {
    setAreaId('');
    setCategoriaId('');
    setSubcategoriaId('');
    setCategorias([]);
    setSubcategorias([]);
  };

  // Función helper para obtener nombres de filtros
  const getNombreArea = (areaId) => {
    const area = areas.find(a => (a.id_area || a.id || a.areaId) == areaId);
    return area?.nombre_area || area?.nombre || area?.areaNombre || areaId;
  };

  const getNombreCategoria = (categoriaId) => {
    const categoria = categorias.find(c => (c.id_categoria || c.id || c.categoriaId) == categoriaId);
    return categoria?.nombre_categoria || categoria?.nombre || categoria?.categoriaNombre || categoriaId;
  };

  const getNombreSubcategoria = (subcategoriaId) => {
    const subcategoria = subcategorias.find(s => (s.id_subcategoria || s.id || s.subcategoriaId) == subcategoriaId);
    return subcategoria?.nombre_subcategoria || subcategoria?.nombre || subcategoria?.subcategoriaNombre || subcategoriaId;
  };

  // Componente para mostrar filtros aplicados
  const FiltrosAplicados = () => {
    if (!areaId && !categoriaId && !subcategoriaId) return null;
    
    return (
      <div style={{ 
        marginTop: '10px', 
        padding: '8px', 
        backgroundColor: '#d1ecf1', 
        border: '1px solid #bee5eb',
        borderRadius: '4px',
        fontSize: '12px',
        color: '#0c5460'
      }}>
        <strong>Filtros aplicados:</strong> 
        {areaId && ` Área: ${getNombreArea(areaId)}`}
        {categoriaId && ` | Categoría: ${getNombreCategoria(categoriaId)}`}
        {subcategoriaId && ` | Subcategoría: ${getNombreSubcategoria(subcategoriaId)}`}
      </div>
    );
  };

  const descargarReporte = async () => {
    if (!fechaInicio || !fechaFin) {
      setError('Por favor, seleccione ambas fechas para descargar el reporte.');
      return;
    }

    setDescargandoReporte(true);
    setError(null);

    try {
      // Convertir los valores vacíos a null para los filtros opcionales
      const areaIdParam = areaId === '' ? null : parseInt(areaId);
      const categoriaIdParam = categoriaId === '' ? null : parseInt(categoriaId);
      const subcategoriaIdParam = subcategoriaId === '' ? null : parseInt(subcategoriaId);
      
      const response = await descargarReporteExcel(fechaInicio, fechaFin, areaIdParam, categoriaIdParam, subcategoriaIdParam);
      if (response.success) {
        // La descarga se maneja automáticamente en la función
        console.log('Reporte descargado exitosamente');
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError('Error al descargar el reporte');
      console.error('Error:', error);
    } finally {
      setDescargandoReporte(false);
    }
  };

  const descargarReporteCerradas = async () => {
    if (!fechaInicio || !fechaFin) {
      setError('Por favor, seleccione ambas fechas para descargar el reporte de tareas cerradas.');
      return;
    }

    setDescargandoReporteCerradas(true);
    setError(null);

    try {
      // Convertir los valores vacíos a null para los filtros opcionales
      const areaIdParam = areaId === '' ? null : parseInt(areaId);
      const categoriaIdParam = categoriaId === '' ? null : parseInt(categoriaId);
      const subcategoriaIdParam = subcategoriaId === '' ? null : parseInt(subcategoriaId);
      
      const response = await descargarReporteTareasCerradas(fechaInicio, fechaFin, areaIdParam, categoriaIdParam, subcategoriaIdParam);
      if (response.success) {
        // La descarga se maneja automáticamente en la función
        console.log('Reporte de tareas cerradas descargado exitosamente');
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError('Error al descargar el reporte de tareas cerradas');
      console.error('Error:', error);
    } finally {
      setDescargandoReporteCerradas(false);
    }
  };

  const descargarReporteTodas = async () => {
    if (!fechaInicio || !fechaFin) {
      setError('Por favor, seleccione ambas fechas para descargar el reporte de todas las tareas.');
      return;
    }

    setDescargandoReporteTodas(true);
    setError(null);

    try {
      const areaIdParam = areaId === '' ? null : parseInt(areaId);
      const categoriaIdParam = categoriaId === '' ? null : parseInt(categoriaId);
      const subcategoriaIdParam = subcategoriaId === '' ? null : parseInt(subcategoriaId);

      const response = await descargarReporteTodasTareas(fechaInicio, fechaFin, areaIdParam, categoriaIdParam, subcategoriaIdParam);
      if (!response.success) {
        setError(response.message || 'No se pudo descargar el reporte de todas las tareas.');
      }
    } catch (error) {
      setError('Error al descargar el reporte de todas las tareas');
      console.error('Error:', error);
    } finally {
      setDescargandoReporteTodas(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>Cargando estadísticas...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p style={{ color: 'red' }}>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1 style={{ marginBottom: '30px', color: '#333' }}>Dashboard de Estadísticas</h1>
      
      {/* Filtros */}
      <div style={{ 
        marginBottom: '30px', 
        padding: '20px', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '8px',
        border: '1px solid #dee2e6'
      }}>
        <h3 style={{ marginBottom: '15px', color: '#333' }}>Filtros de Estadísticas</h3>
        
        {/* Filtro de fechas */}
        <div style={{ marginBottom: '20px' }}>
          <h4 style={{ marginBottom: '10px', color: '#555' }}>Período de Tiempo</h4>
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
            <div>
              <label htmlFor="fechaInicio" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Fecha Inicio:
              </label>
              <input
                type="date"
                id="fechaInicio"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                style={{
                  padding: '8px 12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '150px'
                }}
              />
            </div>
            <div>
              <label htmlFor="fechaFin" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Fecha Fin:
              </label>
              <input
                type="date"
                id="fechaFin"
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
                style={{
                  padding: '8px 12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '150px'
                }}
              />
            </div>
          </div>
        </div>

        {/* Filtros de área, categoría y subcategoría */}
        <div style={{ marginBottom: '20px' }}>
          <h4 style={{ marginBottom: '10px', color: '#555' }}>Filtros Opcionales</h4>
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
            <div>
              <label htmlFor="areaId" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Área:
              </label>
              <select
                id="areaId"
                value={areaId}
                onChange={handleAreaChange}
                disabled={loadingAreas}
                style={{
                  padding: '8px 12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '200px'
                }}
              >
                <option value="">{loadingAreas ? 'Cargando áreas...' : 'Todas las áreas'}</option>
                {areas.map((area) => (
                  <option key={area.id_area || area.id || area.areaId} value={area.id_area || area.id || area.areaId}>
                    {area.nombre_area || area.nombre || area.areaNombre}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="categoriaId" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Categoría:
              </label>
              <select
                id="categoriaId"
                value={categoriaId}
                onChange={handleCategoriaChange}
                disabled={!areaId || loadingCategorias}
                style={{
                  padding: '8px 12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '200px'
                }}
              >
                <option value="">
                  {loadingCategorias 
                    ? 'Cargando categorías...' 
                    : (areaId ? 'Todas las categorías' : 'Seleccione un área primero')}
                </option>
                {categorias.map((categoria) => (
                  <option key={categoria.id_categoria || categoria.id || categoria.categoriaId} value={categoria.id_categoria || categoria.id || categoria.categoriaId}>
                    {categoria.nombre_categoria || categoria.nombre || categoria.categoriaNombre}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="subcategoriaId" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Subcategoría:
              </label>
              <select
                id="subcategoriaId"
                value={subcategoriaId}
                onChange={handleSubcategoriaChange}
                disabled={loadingSubcategorias || !categoriaId || subcategorias.length === 0}
                style={{
                  padding: '8px 12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px',
                  minWidth: '200px'
                }}
              >
                <option value="">
                  {loadingSubcategorias 
                    ? 'Cargando subcategorías...' 
                    : (categoriaId 
                        ? (subcategorias.length > 0 ? 'Todas las subcategorías' : 'No hay subcategorías') 
                        : 'Seleccione categoría')}
                </option>
                {subcategorias.map((subcategoria) => (
                  <option key={subcategoria.id_subcategoria || subcategoria.id || subcategoria.subcategoriaId} value={subcategoria.id_subcategoria || subcategoria.id || subcategoria.subcategoriaId}>
                    {subcategoria.nombre_subcategoria || subcategoria.nombre || subcategoria.subcategoriaNombre}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Botones de acción */}
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button
            onClick={actualizarEstadisticas}
            disabled={loading || !fechaInicio || !fechaFin}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: (loading || !fechaInicio || !fechaFin) ? 'not-allowed' : 'pointer',
              opacity: (loading || !fechaInicio || !fechaFin) ? 0.6 : 1,
              fontSize: '14px'
            }}
          >
            {loading ? 'Actualizando...' : 'Actualizar Estadísticas'}
          </button>
          <button
            onClick={limpiarFiltros}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Limpiar Filtros
          </button>
          <button
            onClick={descargarReporte}
            disabled={descargandoReporte || !fechaInicio || !fechaFin}
            style={{
              padding: '10px 20px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: (descargandoReporte || !fechaInicio || !fechaFin) ? 'not-allowed' : 'pointer',
              opacity: (descargandoReporte || !fechaInicio || !fechaFin) ? 0.6 : 1,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
          >
            📊 {descargandoReporte ? 'Descargando...' : 'Descargar Excel'}
          </button>
          <button
            onClick={descargarReporteTodas}
            disabled={descargandoReporteTodas || !fechaInicio || !fechaFin}
            style={{
              padding: '10px 20px',
              backgroundColor: '#17a2b8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: (descargandoReporteTodas || !fechaInicio || !fechaFin) ? 'not-allowed' : 'pointer',
              opacity: (descargandoReporteTodas || !fechaInicio || !fechaFin) ? 0.6 : 1,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
          >
            📚 {descargandoReporteTodas ? 'Descargando...' : 'Todas las tareas'}
          </button>
          <button
            onClick={descargarReporteCerradas}
            disabled={descargandoReporteCerradas || !fechaInicio || !fechaFin}
            style={{
              padding: '10px 20px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: (descargandoReporteCerradas || !fechaInicio || !fechaFin) ? 'not-allowed' : 'pointer',
              opacity: (descargandoReporteCerradas || !fechaInicio || !fechaFin) ? 0.6 : 1,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
          >
            📋 {descargandoReporteCerradas ? 'Descargando...' : 'Reporte Tareas Cerradas'}
          </button>
        </div>
        
        <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
          Las estadísticas se calculan para el período seleccionado. Los filtros de área, categoría y subcategoría son opcionales.
          Puede seleccionar solo un área, o una categoría específica, o una subcategoría específica.
          <br />
          <strong>Reportes disponibles:</strong> Excel general y Reporte de Tareas Cerradas (ambos respetan los filtros aplicados).
        </p>
        {(!endpointsDisponibles.dashboard || !endpointsDisponibles.area || !endpointsDisponibles.conteoAnidado || !endpointsDisponibles.horas || !endpointsDisponibles.ranking) && (
          <div style={{ 
            marginTop: '15px', 
            padding: '10px', 
            backgroundColor: '#fff3cd', 
            border: '1px solid #ffeaa7', 
            borderRadius: '4px',
            fontSize: '12px',
            color: '#856404'
          }}>
            <strong>Nota:</strong> Algunos endpoints no están disponibles. Se muestran datos de ejemplo para demostración.
          </div>
        )}
      </div>
      
      {/* Tarjetas de resumen */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
        gap: '20px', 
        marginBottom: '40px' 
      }}>
        <div style={{
          backgroundColor: '#007bff',
          color: 'white',
          padding: '20px',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <h3>Total de Tareas</h3>
          <p style={{ fontSize: '2em', margin: '10px 0' }}>{estadisticas.totalTareas}</p>
          <p style={{ fontSize: '12px', opacity: 0.8, marginTop: '5px' }}>
            Período: {fechaInicio} - {fechaFin}
          </p>
        </div>
        
        <div style={{
          backgroundColor: '#ff6b35',
          color: 'white',
          padding: '20px',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <h3>Tareas Pendientes</h3>
          <p style={{ fontSize: '2em', margin: '10px 0' }}>{estadisticas.tareasPendientes}</p>
          <p style={{ fontSize: '12px', opacity: 0.8, marginTop: '5px' }}>
            {estadisticas.totalTareas > 0 ? ((estadisticas.tareasPendientes / estadisticas.totalTareas) * 100).toFixed(1) : 0}% del total
          </p>
        </div>
        
        <div style={{
          backgroundColor: '#28a745',
          color: 'white',
          padding: '20px',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <h3>Tareas Completadas</h3>
          <p style={{ fontSize: '2em', margin: '10px 0' }}>{estadisticas.tareasCompletadas}</p>
          <p style={{ fontSize: '12px', opacity: 0.8, marginTop: '5px' }}>
            {estadisticas.totalTareas > 0 ? ((estadisticas.tareasCompletadas / estadisticas.totalTareas) * 100).toFixed(1) : 0}% del total
          </p>
        </div>
      </div>

      {/* Contenedor principal de gráficos y estadísticas */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
        gap: '30px' 
      }}>
        
        {/* Conteo Anidado - Tareas por Área, Categoría y Subcategoría */}
        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          gridColumn: '1 / -1',
          position: 'relative'
        }}>
          {!endpointsDisponibles.conteoAnidado && (
            <div style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              backgroundColor: '#ffc107',
              color: '#856404',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '10px',
              fontWeight: 'bold'
            }}>
              DEMO
            </div>
          )}
          <h3 style={{ marginBottom: '20px', color: '#333' }}>
            Conteo de Tareas por Área, Categoría y Subcategoría
          </h3>
          <div style={{ 
            height: '400px', 
            overflowY: 'auto',
            padding: '10px',
            backgroundColor: '#f8f9fa',
            borderRadius: '5px'
          }}>
            {conteoAnidado.areas.map((area, areaIndex) => (
              <div key={areaIndex} style={{ marginBottom: '20px' }}>
                {/* Área */}
                <div style={{
                  backgroundColor: '#007bff',
                  color: 'white',
                  padding: '10px 15px',
                  borderRadius: '5px',
                  marginBottom: '10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontWeight: 'bold'
                }}>
                  <span>{area.areaNombre}</span>
                  <span>{area.numeroDeTareas} tareas</span>
                </div>
                
                {/* Categorías */}
                {area.categorias.map((categoria, catIndex) => (
                  <div key={catIndex} style={{ marginLeft: '20px', marginBottom: '15px' }}>
                    <div style={{
                      backgroundColor: '#28a745',
                      color: 'white',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      marginBottom: '8px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      fontSize: '14px'
                    }}>
                      <span>📁 {categoria.categoriaNombre}</span>
                      <span>{categoria.numeroDeTareas} tareas</span>
                    </div>
                    
                    {/* Subcategorías */}
                    {categoria.subcategorias.map((subcategoria, subIndex) => (
                      <div key={subIndex} style={{ marginLeft: '20px', marginBottom: '5px' }}>
                        <div style={{
                          backgroundColor: '#ffc107',
                          color: '#212529',
                          padding: '6px 10px',
                          borderRadius: '3px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          fontSize: '13px'
                        }}>
                          <span>📄 {subcategoria.subcategoriaNombre}</span>
                          <span>{subcategoria.numeroDeTareas} tareas</span>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div style={{ 
            marginTop: '15px', 
            padding: '10px', 
            backgroundColor: '#e9ecef', 
            borderRadius: '4px',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 'bold'
          }}>
            Total de tareas en el período: {conteoAnidado.totalTareas}
          </div>
          
          <FiltrosAplicados />
        </div>

        {/* Horas promedio de resolución */}
        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          textAlign: 'center',
          position: 'relative'
        }}>
          {!endpointsDisponibles.horas && (
            <div style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              backgroundColor: '#ffc107',
              color: '#856404',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '10px',
              fontWeight: 'bold'
            }}>
              DEMO
            </div>
          )}
          <h3 style={{ marginBottom: '20px', color: '#333' }}>Horas Promedio de Resolución</h3>
          <div style={{
            fontSize: '3em',
            fontWeight: 'bold',
            color: '#007bff',
            margin: '20px 0'
          }}>
            {horasPromedio.toFixed(1)}h
          </div>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Tiempo promedio para completar una tarea
          </p>
          <p style={{ color: '#999', fontSize: '12px', marginTop: '10px' }}>
            Período: {fechaInicio} - {fechaFin}
          </p>
          
          <FiltrosAplicados />
        </div>

        {/* Ranking de usuarios de soporte técnico */}
        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          position: 'relative'
        }}>
          {!endpointsDisponibles.ranking && (
            <div style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              backgroundColor: '#ffc107',
              color: '#856404',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '10px',
              fontWeight: 'bold'
            }}>
              DEMO
            </div>
          )}
          <h3 style={{ marginBottom: '20px', color: '#333' }}>Ranking Soporte Técnico</h3>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {rankingSoporte.map((usuario, index) => (
              <div key={index} style={{
                padding: '15px',
                border: '1px solid #eee',
                borderRadius: '8px',
                marginBottom: '10px',
                backgroundColor: index < 3 ? '#f8f9fa' : 'white'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '35px',
                      height: '35px',
                      borderRadius: '50%',
                      backgroundColor: index === 0 ? '#ffd700' : 
                                     index === 1 ? '#c0c0c0' : 
                                     index === 2 ? '#cd7f32' : '#007bff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: 'bold',
                      marginRight: '12px',
                      fontSize: '14px'
                    }}>
                      {index + 1}
                    </div>
                    <div>
                      <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {usuario.nombreResponsable}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        {usuario.emailResponsable}
                      </div>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ 
                      fontWeight: 'bold', 
                      color: '#007bff', 
                      fontSize: '18px',
                      marginBottom: '5px'
                    }}>
                      {usuario.promedioCalificacion?.toFixed(1) || 'N/A'} ⭐
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      {usuario.totalCalificaciones} calificaciones
                    </div>
                  </div>
                </div>
                
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', 
                  gap: '10px',
                  marginTop: '10px'
                }}>
                  <div style={{ textAlign: 'center', padding: '8px', backgroundColor: '#e9ecef', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '2px' }}>Asignadas</div>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{usuario.totalTareasAsignadas}</div>
                  </div>
                  <div style={{ textAlign: 'center', padding: '8px', backgroundColor: '#d4edda', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '2px' }}>Completadas</div>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{usuario.totalTareasCompletadas}</div>
                  </div>
                  <div style={{ textAlign: 'center', padding: '8px', backgroundColor: '#fff3cd', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '2px' }}>Porcentaje</div>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{usuario.porcentajeCompletado?.toFixed(1)}%</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ 
            marginTop: '15px', 
            padding: '10px', 
            backgroundColor: '#e9ecef', 
            borderRadius: '4px',
            textAlign: 'center',
            fontSize: '12px',
            color: '#666'
          }}>
            Período: {fechaInicio} - {fechaFin} | Área: Soporte Técnico
          </div>
          
          <FiltrosAplicados />
        </div>
      </div>
    </div>
  );
};

export default EstadisticasPage; 